import React from 'react';
import { ReactComponent as WarningIcon } from 'assets/images/warning-icon.svg';
import './style.scss';

const Index = ({ message }) => (
    <p className='warning-message'>
        <WarningIcon /> {message || 'Please complete this required field.'}
    </p>
);

export default Index;
